import { MdCancel } from "react-icons/md";
import { BsCardImage } from "react-icons/bs";

export default ({key_, file,files_, setfiles}:any) => {
   

  const pickfile = (key: number) => {
    document.getElementById(`selectlogo${key_}`)?.click();
  };


  return (
    <div className="my-2">
    
   <div className="bg-gray-50 rounded flex items-center w-full border justify-between">
            <div
              onClick={() => {
                pickfile(key_);
              }}
              className=" border border-gray-300 rounded w-[30%] flex justify-center items-center p-2 m-1 font-light text-xs  cursor-pointer"
            > Select file
            </div>
            <p className="text-sm font-light jutify-self-start cursor-pointer     text-textbg  ml-3 truncate ">
              {!(file == undefined) ? file.name : "File title"}
            </p>
            {!(file == undefined) &&
             (  <MdCancel
                onClick={() => {

                  setfiles((prev:any)=>{

                    return prev.filter((i:any)=>i!=file)
                  })                 }}
                size={20}
                className="mr-2 " />  )}
                
                
            <input
              onChange={(event) => {
                const files: any = event.target.files;
               const file_ = files[0];
               console.log(files)
               setfiles((prev:any[])=>files_.filter((i:any)=>i!="").concat([file_]));
              }}
              id={`selectlogo${key_}`}
              type="file"
              className=" hidden "
            /> 
          </div>
    
    </div>
  );
};
